import React from "react";
import AccountManagementComponent from "../../../containers/administration/accountManagement/accountManagementComponent";

import styles from "./accountManagement.module.css";

function AccountManagement() {
  return (
    <div className={styles["component-container"]}>
      <AccountManagementComponent />
    </div>
  );
}

export default AccountManagement;
